import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';

export const mapImportPurchaseToFormValues = (
  purchase: PurchaseDetail
): PurchaseFormValues => {
  const {
    id,
    documentNumber,
    purchaseDate,
    documentType,
    supplier,
    importDetails,
    comments,
    cancellationReason,
    // 👇 capturamos también directamente desde purchase
    totalQuantity,
    netAmount,
    freight,
    insurance,
    fauca,
    otherCosts,
    exportIva,
    totalCost,
  } = purchase;

  return {
    id,
    documentNumber,
    purchaseDate,
    documentType,
    supplier,
    paymentCondition: null,
    creditDueDate: '',
    creditDays: 0,
    comments: comments || '',
    cancellationReason: cancellationReason || '',

    products: importDetails?.products || [],

    totalQuantity: importDetails?.totalQuantity ?? totalQuantity ?? null,
    netAmount: importDetails?.netAmount ?? netAmount ?? null,
    freight: importDetails?.freight ?? freight ?? null,
    insurance: importDetails?.insurance ?? insurance ?? null,
    fauca: importDetails?.fauca ?? fauca ?? null,
    otherCosts: importDetails?.otherCosts ?? otherCosts ?? null,
    exportIva: importDetails?.exportIva ?? exportIva ?? null,
    totalCost: importDetails?.totalCost ?? totalCost ?? null,

    // No aplica para importación
    taxableSubtotal: null,
    calculatedIVA: null,
    withheldIVA: null,
  };
};
